/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Type } from "@adapptio/lib-blueprint";
import { NODE_OUTPUT_NAMES, TAllNodesSpec, TBlueprintVariableNodeOptsSchemaSpec } from "../../blueprints";
import { createSuccessNodeResult, unknownNodeError } from "../helpers";
import { IActionContext, INodeContext, INodeResult } from "../ActionManager";

export async function variableNodeHandler<TSpec extends Partial<TAllNodesSpec>>(
	opts: TBlueprintVariableNodeOptsSchemaSpec,
	aCtx: IActionContext<TSpec>,
	nCtx: INodeContext
): Promise<INodeResult> {
	try {
		const data = opts["value"];

		aCtx.context.debug("Return variable value:", data);

		return createSuccessNodeResult(
			{
				opts,
				outputName: NODE_OUTPUT_NAMES.ON_SUCCESS,
				data,
				typeDescriptor: Type.Any({})
			},
			aCtx,
			nCtx
		);
	} catch (error) {
		return unknownNodeError(opts, error, aCtx, nCtx);
	}
}
